import { LoadingTable } from 'components/core-v2'

import { COLUMN_DEFS } from './columns'

export const EventAssetsLoading = () => (
  <LoadingTable
    showGreyHeader
    agGridProps={{ headerHeight: 60, columnDefs: COLUMN_DEFS }}
    height="400px"
  />
)
